import React from "react"
import type { EmissaoCupomFiscalModel, Filtros } from "../models/emissaoCupomFiscalModel"
import { EmissaoCupomFiscalInicial } from "../models/emissaoCupomFiscalModel"
import type { EmissaoCupomFiscalAction } from "./emissaoCupomFiscalActions"

export type EmissaoCupomFiscalContextValue = {
    dados: EmissaoCupomFiscalModel
    dispatch: React.Dispatch<EmissaoCupomFiscalAction>
    erroCarregamento: string | null
    carregarCupons: (filtros: Filtros) => Promise<void>
    sincronizarCupons: () => Promise<void>
    atualizarPendentes: () => Promise<void>
    cancelarCupom: (idNfce: number) => Promise<void>
    reimprimirCupom: (idNfce: number) => Promise<void>
}

export const EmissaoCupomFiscalContext = React.createContext<EmissaoCupomFiscalContextValue>({
    dados: EmissaoCupomFiscalInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    carregarCupons: async () => undefined,
    sincronizarCupons: async () => undefined,
    atualizarPendentes: async () => undefined,
    cancelarCupom: async () => undefined,
    reimprimirCupom: async () => undefined,
})
